import styled from 'styled-components';

export const Container = styled.div`
  width: min(92vw, 980px);
  min-height: 60vh;
  max-height: calc(100vh - 3rem);
  background: #fffefc;
  border-radius: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e3e2e2;
`;

export const Title = styled.h3`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.15rem;
  color: #323232;
  margin: 0;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 0.5rem;
  background: transparent;
  color: #323232;
  cursor: pointer;
  transition:
    background 0.2s,
    color 0.2s;

  &:hover {
    background: #f2f2f2;
    color: #1e88e5;
  }
`;

export const Body = styled.div`
  padding: 1.25rem;
  overflow-y: auto;
  display: flex;
  justify-content: center;

  > * {
    width: 100%;
  }
`;

export const LoadingState = styled.div`
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-family: 'RedHatDisplay-Regular';
`;
